import React, { useState, useEffect } from "react";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import Header from "../../Common/Layout/Header";
import { useAuth } from "../../Common/Configurations/AuthContext";
import Modal from "react-bootstrap/Modal";
import { Link, useNavigate } from "react-router-dom";
import AdminTabs from "../AllTabs/AdminTabs";

const Companies = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [lists, setLists] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [itemToChangeStatus, setItemToChangeStatus] = useState(null);
  const [loadingStatus, setLoadingStatus] = useState(false);

  const handleOpenStatusModal = (company) => {
    setItemToChangeStatus(company);
    setShowStatusModal(true);
  };

  const handleCloseStatusModal = () => {
    setShowStatusModal(false);
    setItemToChangeStatus(null);
  };

  const GetData = async (pageNumber) => {
    try {
      const res = await apiService.getWithParams(
        `${config.GETCOMPANIES}?companyType=COMPANY`
      );

      setLists(res.data || []);
      setPageNumber(res.pageNumber || 1);
      setPageSize(res.pageSize || 20);
      setTotalPages(res.totalPages || 0);
      setTotalRecords(res.totalRecords || 0);
    } catch (error) {
      console.error("Error fetching companies:", error);
      setLists([]);
    }
  };

  const GetLastPageData = () => {
    GetData(totalPages);
  };

  const GetFirstPageData = () => {
    GetData(1);
  };

  const GetPageData = (number) => {
    setPageNumber(number);
    if (pageNumber !== number) GetData(number);
  };

  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  const renderPageNumbers = pageNumbers.map((number) => {
    return (
      <li
        className="page-item"
        key={number}
        id={number}
        onClick={() => GetPageData(number)}
      >
        <Link className="page-link">{number}</Link>
      </li>
    );
  });

  const handleStatusChange = async () => {
    if (itemToChangeStatus !== null) {
      setLoadingStatus(true);
      try {
        const newStatus = !itemToChangeStatus.isActive;

        // Use query parameter in the URL
        await apiService.update(
          `${config.UPDATECOMPANYSTATUS}/${itemToChangeStatus.companyId}?isActive=${newStatus}`,
          {} // Empty body since we're using query params
        );

        // Update local state immediately for better UX
        setLists((prevLists) =>
          prevLists.map((company) =>
            company.companyId === itemToChangeStatus.companyId
              ? { ...company, isActive: newStatus }
              : company
          )
        );
      } catch (error) {
        console.error("Error updating company status:", error);
        // Optional: Show error message to user
        alert("Failed to update company status. Please try again.");
      } finally {
        setLoadingStatus(false);
        handleCloseStatusModal();
      }
    }
  };

  useEffect(() => {
    if (user && !loading) {
      GetData(pageNumber);
    }
  }, [user, loading]);

  if (loading) return <p>Loading...</p>;
  if (!user) {
    navigate("/");
  }

  return (
    <div id="layout-wrapper">
      <Header User={user} />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="col-xl-12">
              <div className="card">
                <div className="p-2">
                  <AdminTabs pageName="COMPANIES" />
                </div>
                <div className="card-body">
                  <div className="table-responsive table-card p-2">
                    <table className="table align-middle" id="customerTable">
                      <thead className="table-light">
                        <tr>
                          <th>S.NO</th>
                          <th>Company Name</th>
                          <th>Brand Name</th>
                          <th>Email</th>
                          <th>Phone</th>
                          <th>GST No</th>
                          <th>Type</th>
                          <th>Plan</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody className="list form-check-all">
                        {lists.length > 0 ? (
                          lists.map((v, index) => (
                            <tr key={v.companyId}>
                              <td>{index + 1}</td>
                              <td>{v.companyName}</td>
                              <td>{v.brandName || "-"}</td>
                              <td>{v.email}</td>
                              <td>{v.phoneNumber}</td>
                              <td>{v.gstNo || "-"}</td>
                              <td>
                                <span className="badge bg-info fs-6">
                                  {v.companyType}
                                </span>
                              </td>
                              <td>
                                <span className="badge bg-primary fs-6">
                                  {v.planType}
                                </span>
                              </td>
                              <td>
                                <span
                                  className={`badge ${
                                    v.isActive ? "bg-success" : "bg-danger"
                                  } fs-6`}
                                >
                                  {v.isActive ? "Active" : "Inactive"}
                                </span>
                              </td>
                              <td>
                                <ul className="list-inline hstack gap-2 mb-0">
                                  <li
                                    className="list-inline-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-trigger="hover"
                                    data-bs-placement="top"
                                    title={
                                      v.isActive
                                        ? "Deactivate Company"
                                        : "Activate Company"
                                    }
                                  >
                                    <Link
                                      className="edit-item-btn"
                                      onClick={() => handleOpenStatusModal(v)}
                                    >
                                      <i
                                        className={`fs-2 ${
                                          v.isActive
                                            ? "ri-toggle-fill text-success"
                                            : "ri-toggle-line text-danger"
                                        }`}
                                      />
                                    </Link>
                                  </li>
                                </ul>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="11" className="text-center py-4">
                              <div className="text-muted">
                                <i className="ri-building-2-line display-4"></i>
                                <p className="mt-2">No companies found</p>
                              </div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  {lists.length > 0 && (
                    <div className="align-items-center mt-4 pt-2 justify-content-between d-flex">
                      <div className="flex-shrink-0">
                        <div className="text-muted">
                          Showing{" "}
                          <span className="fw-semibold">{lists.length}</span> of{" "}
                          <span className="fw-semibold">{totalRecords}</span>{" "}
                          Results
                        </div>
                      </div>
                      <ul className="pagination pagination-separated pagination-sm mb-0">
                        <li
                          className="page-item"
                          onClick={() => GetFirstPageData()}
                        >
                          <Link className="page-link">Previous</Link>
                        </li>
                        {renderPageNumbers}
                        <li
                          className="page-item"
                          onClick={() => GetLastPageData()}
                        >
                          <Link className="page-link">Next</Link>
                        </li>
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Status Change Modal */}
        <Modal show={showStatusModal} onHide={handleCloseStatusModal} centered>
          <Modal.Body className="text-center p-5">
            <div className="mb-4">
              <h4>
                {itemToChangeStatus?.isActive
                  ? "Deactivate Company"
                  : "Activate Company"}
              </h4>
              <p className="text-muted mt-2">
                Are you sure you want to{" "}
                {itemToChangeStatus?.isActive ? "deactivate" : "activate"} the
                company <strong>{itemToChangeStatus?.companyName}</strong>?
                {itemToChangeStatus?.isActive
                  ? " This will also deactivate all associated users."
                  : " This will also activate all associated users."}
              </p>
            </div>
            <div className="d-flex justify-content-center gap-3">
              <button
                type="button"
                className="btn btn-danger"
                onClick={handleCloseStatusModal}
                disabled={loadingStatus}
              >
                Cancel
              </button>
              <button
                type="button"
                className={`btn ${
                  itemToChangeStatus?.isActive ? "btn-warning" : "btn-success"
                }`}
                onClick={handleStatusChange}
                disabled={loadingStatus}
              >
                {loadingStatus ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" />
                    Please wait...
                  </>
                ) : itemToChangeStatus?.isActive ? (
                  "Deactivate"
                ) : (
                  "Activate"
                )}
              </button>
            </div>
          </Modal.Body>
        </Modal>
      </div>

      {/* <style>{`
        .badge.bg-success {
          background: linear-gradient(45deg, #198754, #2ea65c);
        }
        .badge.bg-danger {
          background: linear-gradient(45deg, #dc3545, #e63749);
        }
        .badge.bg-info {
          background: linear-gradient(45deg, #0dcaf0, #25cff2);
        }
        .badge.bg-primary {
          background: linear-gradient(45deg, #0d6efd, #3b82f6);
        }
        .badge {
          padding: 0.5em 0.8em;
          border-radius: 20px;
          font-weight: 500;
          box-shadow: 0 2px 5px rgba(0,0,0,0.1);
        }
      `}</style> */}
    </div>
  );
};

export default Companies;
